// Shared form control classes — keeps every input/select/textarea/label in
// the app visually identical without a heavyweight Field component.

export const labelClass = 'block text-sm font-medium text-slate-700 dark:text-slate-200';

export const inputClass =
  'mt-1 block w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 ' +
  'dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100 dark:placeholder-slate-500 ' +
  'placeholder:text-slate-400 focus:border-slate-500 focus:outline-none focus:ring-1 focus:ring-slate-500';

// Inline select control (e.g. compact pickers that sit beside other controls
// rather than stacking under a label). Same visual language as inputClass,
// minus the top margin so it lines up in a flex row.
export const selectClass =
  'rounded-md border border-slate-300 bg-white px-3 py-1.5 text-sm text-slate-900 ' +
  'dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100 ' +
  'focus:border-slate-500 focus:outline-none focus:ring-1 focus:ring-slate-500';
